import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ICPLCoreConnectService } from "services/CPLCoreConnectService";
import { CustomURISchemeTypes } from "services/api/cplapi/CPLAPI";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";
import { URISchemeTypes } from "../URISchemeTypes";

const initialState = {
  LoadingSave: false,
};

export const cplCoreConnectSlice = createSlice({
  name: "cplCoreConnect",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(saveCustomData.pending, (state) => {
        state.LoadingSave = true;
      })
      .addCase(saveCustomData.fulfilled, (state) => {
        state.LoadingSave = false;
      })
      .addCase(saveCustomData.rejected, (state) => {
        state.LoadingSave = false;
      });
  },
});

export const saveCustomData = createAsyncThunk(
  "cplCoreConnect/SaveCustomData",
  async ({ customUriSchemeType, dataModel }: { customUriSchemeType: CustomURISchemeTypes; dataModel: object }) => {
    const cplCoreConnectService = container.get<ICPLCoreConnectService>(SERVICE_TYPES.CPLCoreConnectService);
    const jsonDataModel = JSON.stringify(dataModel);
    const customSchemeID = await cplCoreConnectService.saveCustomData(customUriSchemeType, jsonDataModel);
    const cplCoreModel = {
      URISchemeTypeID: URISchemeTypes.Custom,
      Data: customSchemeID,
    };
    const encodedParameter = window.btoa(JSON.stringify(cplCoreModel));
    const location = "CPL:" + encodedParameter;
    window.open(location);
  }
);

export default cplCoreConnectSlice.reducer;
